import { useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { useMutation, useQuery, useLazyQuery } from "@apollo/client";
import { useDispatch, useSelector } from "react-redux";

import ChatContainer from "./components/ChatContainer";
import ChatRoomList from "./components/ChatRoomList";
import EmptyChat from "./components/EmptyChat";
import SocketClient from "../../services/SocketClient";
import {
  CREATE_MESSAGE_NOTIFICATION,
  SEND_MESSAGE,
} from "../../graphql/mutations/message";
import { SOCKET_CLIENT } from "../../constants/socket";
import {
  GET_CHAT_ROOM_LIST,
  GET_MESSAGES,
} from "../../graphql/queries/message";
import { clearMessage } from "./redux/chatSlice";
import { showErrorToast } from "../../components/common/CustomErrorMessage";

const Chat = () => {
  const dispatch = useDispatch();
  const chat = useSelector((state) => state.chat);
  const { currentChat } = chat;
  const { data: { getChatRoomList } = {}, refetch: refetchChatRoom } =
    useQuery(GET_CHAT_ROOM_LIST);
  const [loadMessages, { data: { getAdminMessages } = {}, refetch }] =
    useLazyQuery(GET_MESSAGES, {
      variables: { memberId: currentChat?.memberId },
    });

  const [createNotification] = useMutation(CREATE_MESSAGE_NOTIFICATION, {
    onCompleted: (data) => {
      if (data.createChatNotification) {
        SocketClient.emit(
          SOCKET_CLIENT.SEND_CHAT_NOTIFICATION,
          data.createChatNotification
        );
      }
    },
    onError: (error) => {
      showErrorToast(error.message);
    },
  });

  const [sendMessage] = useMutation(SEND_MESSAGE, {
    onCompleted: (data) => {
      if (data.sendMessage) {
        SocketClient.emit(SOCKET_CLIENT.SEND_MESSAGE, data.sendMessage);
        dispatch(clearMessage());
        refetch();
        refetchChatRoom();
        createNotification({
          variables: {
            input: {
              member: data.sendMessage.member.id,
              message: data.sendMessage.id,
              toAdmin: false,
            },
          },
        });
      }
    },
    onError: (error) => {
      showErrorToast(error.message, "ໂຫຼດຂໍ້ຄວາມ");
    },
  });

  useEffect(() => {
    SocketClient.on(SOCKET_CLIENT.RECIEVE_MESSAGE, (data) => {
      if (data.chatRoom.id === currentChat?.chatRoomId) {
        refetch();
        refetchChatRoom();
      }
    });
  }, [currentChat, refetch, refetchChatRoom, sendMessage]);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = "scroll");
  });

  return (
    <div className="chat-page">
      <Row>
        <Col md="4">
          <ChatRoomList data={getChatRoomList} loadMessages={loadMessages} />
        </Col>
        <Col md="8">
          {currentChat.chatRoomId ? (
            <ChatContainer
              sendMessage={sendMessage}
              getMessages={getAdminMessages}
              refetchChatRoom={refetchChatRoom}
              refetch={refetch}
            />
          ) : (
            <EmptyChat />
          )}
        </Col>
      </Row>
    </div>
  );
};

export default Chat;
